/* eslint-disable class-methods-use-this */
import * as api from '../../../../utils/apiClient';

class TasksManage {
  async changeStatus(taskId, body) {
    const response = await api.post(
      `/tasks/manage-task/${taskId}/change-status`,
      {},
      body
    );
    const responseJson = await response.json();
    return responseJson;
  }
}

export default new TasksManage();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/services/TasksManage/index.js